$.ready(function() {
	var autoplay = game.autoplay = {};
	
	autoplay.state = {};
	
	autoplay.set = function(count) {
		autoplay.state.count = count;
		
		if (!autoplay.state.count || typeof autoplay.state.count !== 'number') {
			if (autoplay.state.active) {
				if (game.panel.type === 'desktop') {
					game.panel.spin.label.html('Spin');
				}
				
				if (game.panel.type === 'mobile') {
					game.panel.play.removeClass('icon-stop').addClass('icon-spin');
				}
			}
			
			autoplay.state.count = 0;
			autoplay.state.active = false;
		}
		
		if (game.panel.type === 'desktop') {
			if (autoplay.state.count) {
				game.panel.auto.label.html(autoplay.state.count);
			}
			
			else {
				game.panel.auto.label.html('Auto');
			}
		}
		
		if (game.panel.type === 'mobile') {
			if (autoplay.state.count > 0) {
				game.panel.play.set(autoplay.state.count);
			}
			
			else {
				game.panel.play.set('');
			}
		}
	};
	
	autoplay.isActive = function() {
		return !game.feature.active && autoplay.state.active;
	};
	
	game.on('round_init', function(e) {
		if(e.detail.recall) {
			return;
		}

		if (game.feature.active) {
			return;
		}
		
		if (autoplay.state.count <= 1) {
			autoplay.set(0);
			
			return;
		}

		autoplay.state.active = true;
		autoplay.set(autoplay.state.count - 1);
		
		if (game.panel.type === 'desktop') {
			game.panel.spin.label.html('Stop');
		}
		
		if (game.panel.type === 'mobile') {
			game.panel.play.removeClass('icon-spin').addClass('icon-stop');
		}
	});
	
	game.on('round_complete', function() {
		if (game.feature.active) {
			return;
		}
		
		if (autoplay.state.count <= 0) {
			autoplay.set(0);
			
			return;
		}
		
		setTimeout(function() {
			if (autoplay.state.count <= 0) {
				autoplay.set(0);
				
				return;
			}
			
			game.play();
		}, 1000);
	});
	
	/* Panel */
	{
		if (game.panel.type === 'desktop') {
			game.panel.auto = $.div().addClass('auto').apply('counter', { label: 'Auto', menu: true, menu_disabled: false });
			game.panel.auto.removeClass('counter').addClass('button');
			game.panel.auto.menu.addClass('small');
			game.panel.addItem(game.panel.auto, 'left mini');
			
			game.panel.auto.on('click', function(e) {
				if (e.target === this.el || e.target === this.label.el) {
					game.sounds.play([ 'buttons', 'auto' ]);
				}
			});
			
			game.panel.auto.on('update', function() {
				autoplay.set(this.get());
				
				game.sounds.play([ 'buttons', 'autos', 'auto_' + this.value ]);
			});
		}
		
		if (game.panel.type === 'mobile') {
			autoplay.bet = $.div();
			autoplay.bet.slug = 'bet';
			
			autoplay.bet.play = $.div().apply('button', { label: 'Bet play' }).addClass('play center').appendTo(autoplay.bet);
			autoplay.bet.play.on('click', function() {
				game.panel.dialog.hide();
				autoplay.set(game.panel.auto.get());
			});
			
			game.panel.auto = $.div().apply('roller', { label: 'Auto Play' }).appendTo(autoplay.bet);
			
			game.panel.auto.on('update', function() {
				autoplay.set(this.get());
				game.sounds.play([ 'buttons', 'autos', this.value ]);
			});
			
			game.panel.hud.auto = $.div().apply('button', { label: 'Auto Play' });
			game.panel.addItem(game.panel.hud.auto, 'hud right top');
			
			game.panel.hud.auto.on('click', function(e) {
				game.panel.dialog.show(autoplay.bet);
				game.panel.hud.hide();
				
				if (e.target === this.el || e.target === this.label.el) {
					game.sounds.play([ 'buttons', 'auto' ]);
				}
			});
		}
	}
	
	game.on('ui', function(config) {
		config = config.detail;
		
		var autoplay = [];
		
		for (var d = 0; d < config.bet.autoplay.length; d++) {
			autoplay.push($.plugins.meter.__format(config.bet.autoplay[d]));
		}
		
		config.bet.autoplay.reverse();
		autoplay.reverse();
		
		config.bet.autoplay.push(0);
		autoplay.push('Off');
		
		game.panel.auto.reset(config.bet.autoplay, -1, autoplay);
	});
});



/** WEBPACK FOOTER **
 ** ./../../public-src/common/js/autoplay.js
 **/